var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9011 2.37975C12.4207 1.85711 13.2719 1.84848 13.8023 2.36048L14.7627 3.28753C15.2931 3.79953 15.3019 4.63826 14.7823 5.1609L9.60764 10.3657C9.34783 10.627 8.92222 10.6313 8.65701 10.3753C8.39181 10.1193 8.38743 9.69994 8.64724 9.43862L11.9402 6.12649L10.9798 5.19944L4.39388 11.8237L5.35428 12.7507L6.76555 11.3313C7.02535 11.0699 7.45096 11.0656 7.71617 11.3216C7.98138 11.5776 7.98575 11.997 7.72595 12.2583L5.09827 14.9013C4.84874 15.1523 4.50825 15.2953 4.15169 15.2989L2.52888 15.3154C2.15764 15.3191 1.85359 15.0256 1.84977 14.6598L1.83308 13.0608C1.82941 12.7095 1.96753 12.3711 2.21706 12.1201L11.9011 2.37975ZM4.41343 13.6971L3.45303 12.77L3.17746 13.0472L3.18724 13.9839L4.13787 13.9742L4.41343 13.6971ZM11.9206 4.25312L12.881 5.18017L13.8219 4.23385L12.8615 3.3068L11.9206 4.25312Z",
    fill: "#1F2D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.65c42dd4d4f055fa6ea4f071d9f1e40a.svg";
export { ForwardRef as ReactComponent };